
import { Options, Vue } from 'vue-class-component';
import api from '@/shared/api';
import session from '@/shared/session';

const FAILED_PAYMENT_STATUSES = new Set(['failed', 'canceled', 'cancelled', 'expired']);

@Options({})
export default class SubscriptionPaymentCallback extends Vue {
    orderId = '';
    error = '';
    statusMessage = 'Confirming your payment…';

    async created() {
        this.orderId = (this.$route.query.orderId as string) || '';
        if (!this.orderId) {
            this.error = 'Missing order reference. Return to the subscription page and try again.';
            return;
        }

        await this.waitForPaymentComplete();
    }

    async waitForPaymentComplete() {
        try {
            const status = await api.getBusinessUnitSubscriptionOrderStatus(this.orderId);

            if (status.paymentStatus === 'paid') {
                this.statusMessage = 'Activating your subscription…';
                await api.completeBusinessUnitSubscriptionPayment(this.orderId);
                await session.refreshBusinessUnits();
                await this.$router.push({ name: 'credits' });
                return;
            }

            if (status.paymentStatus && FAILED_PAYMENT_STATUSES.has(status.paymentStatus)) {
                this.error = 'Payment was not completed. You can try again from the subscription page.';
                return;
            }

            setTimeout(() => {
                this.waitForPaymentComplete();
            }, 1000);
        } catch (e: unknown) {
            const message = e instanceof Error ? e.message : 'Something went wrong while confirming payment.';
            this.error = message;
        }
    }
}
